import React from 'react';
import { useTranslation } from 'react-i18next';
import { BodyText, Flex, Table, Tag } from '@gaiads/telia-react-component-library';
import { VariantOverview } from '@cdaas/api-clients/dist/product-service-openapi';

interface MainListItemProps {
  item: VariantOverview;
}

const MainListItem = ({ item }: MainListItemProps) => {
  const { t } = useTranslation('bundlesview');
  const { name, sku } = item;
  return (
    <Table.Row className="telia-react-table_row__child">
      <Table.Cell></Table.Cell>
      <Table.Cell></Table.Cell>
      <Table.Cell></Table.Cell>
      <Table.Cell className="daas-product-table__name">
        <Flex>
          <Flex flexItem>
            <BodyText>{name}</BodyText>
          </Flex>
          <Flex flexItem>
            <Tag className={'telia-react-table_row__variants'} backgroundColor={'purple500'}>
              {t('bundles_table.main')}
            </Tag>
          </Flex>
        </Flex>
      </Table.Cell>
      <Table.Cell></Table.Cell>
      <Table.Cell>
        <BodyText>{sku}</BodyText>
      </Table.Cell>
      <Table.Cell></Table.Cell>
      <Table.Cell></Table.Cell>
      <Table.Cell></Table.Cell>
    </Table.Row>
  );
};

export default MainListItem;
